"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "contractAttachments",
    path: "/contract-attachments",
    component: "ContractAttachments"
});
let ContractAttachments = class ContractAttachments extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    gridName;
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('browse_contract_attachments');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['gridName', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                gridName: "contractAttachments",
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "contract_revision",
                        name: this.$fn.pgettext("ContractAttachments", "Contract"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    {{ $value.contract_number }}\n\
    {{~#if $value.revision_number }}\n\
      /{{ $value.revision_number }}\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "contract",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "contract_revision.contract_id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "file_name",
                        name: this.$fn.pgettext("ContractAttachments", "File name"),
                        useDataContext: true,
                        displayFileName: true,
                        formatter: "attachment",
                        type: "command",
                    },
                    {
                        field: "file_size",
                        name: this.$fn.pgettext("ContractAttachments", "File size"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("ContractAttachments", "Description"),
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                    {
                        field: "created_by",
                        name: this.$fn.pgettext("ContractAttachments", "Created by"),
                        formatter: {
                            name: "user",
                        },
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("ContractAttachments|Title", "Contract Attachments"),
                icon: this.$config.attachment.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_6906_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_6908_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_script_6910_getActionArgs_value($event) {
        (console.log($event), this.$app.attachments.downloadAttachment($event.data.data));
    }
    async act_2248226175642056_script_6910_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_6910_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_command_6909_getWhen($event) {
        return $event.data.column.id === 'file_name';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_6906 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_6906_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_6905 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_6906,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_6905],
        });
        const act_2248226175642056_setData_6908 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_6908_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_6907 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_6908,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_6907],
        });
        const act_2248226175642056_script_6910 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_6910_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_6909 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_6910,
            event: "command",
            when: this.evh_2248226175642056_command_6909_getWhen,
            displayName: "script",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_6909],
        });
        return {
            act_7315092382398562_closeModal_6906,
            evh_7315092382398562_close_6905,
            evh_7315092382398562_close,
            act_2248226175642056_setData_6908,
            evh_2248226175642056_selectedRowsChanged_6907,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_script_6910,
            evh_2248226175642056_command_6909,
            evh_2248226175642056_command,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ContractAttachments.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractAttachments.prototype, "onSize", null);
ContractAttachments = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractAttachments);
exports.default = ContractAttachments;
vue_property_decorator_1.Vue.component("ContractAttachments", ContractAttachments);
